import { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const cache = new Map(); // `${slug}:${locale}:${preview}` → Promise<{data, seo}>

function fetchPage(slug, locale, preview) {
    const key = `${slug}:${locale}:${preview ? 1 : 0}`;
    if (!cache.has(key)) {
        const url = `${API}/pages/${slug}?lang=${locale}${preview ? "&preview=1" : ""}`;
        const p = axios
            .get(url, { withCredentials: preview })
            .then((r) => ({ data: r.data.data || {}, seo: r.data.seo || {} }))
            .catch(() => ({ data: {}, seo: {} }));
        cache.set(key, p);
    }
    return cache.get(key);
}

export function invalidatePage(slug) {
    for (const k of Array.from(cache.keys())) {
        if (k.startsWith(`${slug}:`)) cache.delete(k);
    }
}

export default function usePageContent(slug) {
    const location = useLocation();
    const { locale } = useLanguage();
    const params = new URLSearchParams(location.search);
    const preview = params.get("preview") === "1";
    const [state, setState] = useState({ data: null, seo: {} });

    useEffect(() => {
        let alive = true;
        fetchPage(slug, locale, preview).then((d) => {
            if (alive) setState({ data: d.data, seo: d.seo });
        });
        return () => {
            alive = false;
        };
    }, [slug, locale, preview]);

    const t = (key, defaultValue) => {
        if (state.data === null) return defaultValue;
        const v = state.data[key];
        if (v === undefined || v === null || v === "") return defaultValue;
        return v;
    };
    t.isPreview = preview;
    t.loaded = state.data !== null;
    t.seo = state.seo || {};
    t.locale = locale;
    return t;
}
